import ScpmFilter from './ScpmFilter.vue';
import ScpmFilterDialog from './ScpmFilterDialog.vue';

export default {
  install(Vue) {
    Vue.component('scpm-filter', ScpmFilter);
    Vue.component('scpm-filter-dialog', ScpmFilterDialog);
  },
};
